export function separator(number: number, separator = ',', zero = true): string {
    if (!number && zero) return '0';
    const parts = number.toString().split('.');
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? '.' + parts[1] : '';
    return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator) + decimalPart;
}

export function calculateDiscountPercentage(displayPrice: number, originalPrice: number): number {
    if (originalPrice <= 0 || displayPrice > originalPrice) {
        return 0;
    }
    const discount = ((originalPrice - displayPrice) / originalPrice) * 100;
    return Math.round(discount);
}

export function formatCompactNumber(value: number | null | undefined, decimals = 1): string {
    if (value === null || value === undefined || Number.isNaN(value)) return '0';
    const num = Number(value);
    if (!isFinite(num)) return String(num);

    const negative = num < 0;
    const abs = Math.abs(num);

    if (abs < 1000) {
        return (negative ? '-' : '') + String(Math.trunc(abs));
    }

    const units = ['k', 'M', 'B', 'T'] as const;
    let unitIndex = -1;
    let scaled = abs;

    while (scaled >= 1000 && unitIndex < units.length - 1) {
        scaled = scaled / 1000;
        unitIndex++;
    }

    const factor = Math.pow(10, decimals);
    let formatted: number | string = Math.round(scaled * factor) / factor;
    formatted = formatted % 1 === 0 ? formatted.toFixed(0) : String(formatted);

    return (negative ? '-' : '') + formatted + units[unitIndex];
}

export function isPositive(num: number): boolean {
    return num > 0;
}

export function isNegative(num: number): boolean {
    return num < 0;
}

export function formatTime(seconds: number) {
    if (isNaN(seconds)) return '00:00';
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}″:${minutes < 10 ? '0' : ''}${minutes}′`;
}

export function toOrdinalPersian(num: number) {
    if (num < 1) return 'عدد نامعتبر';

    const ones = ['', 'اول', 'دوم', 'سوم', 'چهارم', 'پنجم', 'ششم', 'هفتم', 'هشتم', 'نهم'];
    const tens = ['', 'دهم', 'بیستم', 'سی‌ام', 'چهلم', 'پنجاهم', 'شصتم', 'هفتادم', 'هشتادم', 'نودم'];
    const teens = ['دهم', 'یازدهم', 'دوازدهم', 'سیزدهم', 'چهاردهم', 'پانزدهم', 'شانزدهم', 'هفدهم', 'هجدهم', 'نوزدهم'];
    const hundreds = ['', 'صدم', 'دویستم', 'سیصدم', 'چهارصدم', 'پانصدم', 'ششصدم', 'هفتصدم', 'هشتصدم', 'نهصدم'];

    if (num === 1000) return 'هزارم';

    if (num < 10) {
        return ones[num];
    }

    if (num < 20) {
        return teens[num - 10];
    }

    if (num < 100) {
        const ten = Math.floor(num / 10);
        const one = num % 10;
        if (one === 0) {
            return tens[ten];
        }
        return ones[one] + ' و ' + tens[ten];
    }

    if (num < 1000) {
        const hundred = Math.floor(num / 100);
        const remainder = num % 100;

        if (remainder === 0) {
            return hundreds[hundred];
        }

        let result = '';
        if (remainder < 10) {
            result = ones[remainder];
        } else if (remainder < 20) {
            result = teens[remainder - 10];
        } else {
            const ten = Math.floor(remainder / 10);
            const one = remainder % 10;
            if (one === 0) {
                result = tens[ten];
            } else {
                result = ones[one] + ' و ' + tens[ten];
            }
        }

        return result + ' و ' + hundreds[hundred];
    }

    return 'عدد خارج از محدوده';
}

